module.exports = __webpack_public_path__ + "static/img/12.c5292383.jpg";